import { useEffect } from "react";
import { Form, Typography, Alert, message } from "antd";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/CustomButton/Button";
import CustomInput from "../../components/CustomInput/Input";
import AuthCardLayout from "../../components/Auth/AuthCardLayout";
import { sendOtp, clearAuthError } from "../../redux/slices/AuthSlice";
import { useDispatch, useSelector } from "react-redux";
import { emailRules } from "../../helpers/helpers";
import { BTN_TXT, DESC_TXT, GLOBAL_CONSTANTS } from "../../constants/constants";

const { Text } = Typography;

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);

  useEffect(() => {
    return () => {
      dispatch(clearAuthError());
    };
  }, [dispatch]);

  const onFinish = async (values) => {
    const { email } = values;
    const res = await dispatch(sendOtp(email));

    if (res.payload?.statusCode === 200) {
      message.success("OTP sent successfully!");
      const messageId = res.payload?.response?.result?.message || res.payload?.response;
      navigate("/otp", {
        state: { email: email, messageId },
      });
    }
  };

  return (
    <AuthCardLayout
      title={GLOBAL_CONSTANTS.FORGOT_PWD}
      subtitle={<Text>{DESC_TXT.FORGOT_PWD_INFO_TEXT}</Text>}
    >
      <Form
        layout="vertical"
        className="forgot-form"
        onFinish={onFinish}
        initialValues={{ remember: true }}
      >
        <CustomInput
          label="Email"
          name="email"
          placeholder="Your Email"
          rules={emailRules("")}
        />

        {error && <Alert message={error} type="error" showIcon style={{ marginTop: 10 }} />}

        <Form.Item>
          <CustomButton
            type="primary"
            htmlType="submit"
            loading={loading}
            block
            style={{ marginTop: 30, padding: 24 }}
          >
            {BTN_TXT.SEND_OTP}
          </CustomButton>
        </Form.Item>

        <Form.Item>
          <CustomButton
            type="text"
            block
            style={{ fontWeight: 600, padding: 0 }}
            onClick={() => navigate("/login")}
          >
            {BTN_TXT.BACK}
          </CustomButton>
        </Form.Item>
      </Form>
    </AuthCardLayout>
  );
};

export default ForgotPassword;
